const url = 'https://push.api.cx.metamask.io';
export const REGISTRATION_TOKENS_ENDPOINT = `${url}/v1/link`;
